// extracted by mini-css-extract-plugin
export default {"relativeContainer":"moHCnT","container":"fTEXDR"};